import type { IconProps } from "@/types/icon";

const Diabetic = ({ color = "black", className }: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.59516 0.819118C9.53095 0.719706 9.44285 0.637967 9.33891 0.581369C9.23497 0.524771 9.11851 0.495117 9.00016 0.495117C8.88181 0.495117 8.76535 0.524771 8.66142 0.581369C8.55748 0.637967 8.46938 0.719706 8.40516 0.819118C8.35558 0.897035 3.3335 8.80912 3.3335 11.8337C3.3335 13.3366 3.93052 14.7779 4.99322 15.8406C6.05593 16.9033 7.49727 17.5004 9.00016 17.5004C10.5031 17.5004 11.9444 16.9033 13.0071 15.8406C14.0698 14.7779 14.6668 13.3366 14.6668 11.8337C14.6668 8.8162 9.64475 0.897035 9.59516 0.819118ZM9.00016 15.5454C8.01569 15.5435 7.07196 15.1521 6.37517 14.4566C5.67838 13.7611 5.28515 12.8182 5.28141 11.8337C5.28141 11.6928 5.33738 11.5577 5.43701 11.4581C5.53664 11.3584 5.67177 11.3025 5.81266 11.3025C5.95356 11.3025 6.08868 11.3584 6.18831 11.4581C6.28794 11.5577 6.34391 11.6928 6.34391 11.8337C6.34765 12.5364 6.62893 13.2091 7.12646 13.7053C7.624 14.2015 8.29748 14.481 9.00016 14.4829C9.14106 14.4829 9.27618 14.5388 9.37581 14.6385C9.47544 14.7381 9.53141 14.8732 9.53141 15.0141C9.53141 15.155 9.47544 15.2901 9.37581 15.3898C9.27618 15.4894 9.14106 15.5454 9.00016 15.5454Z"
      fill={color}
    />
  </svg>
);

export default Diabetic;
